// extracted by mini-css-extract-plugin
module.exports = {"editor-window":"EditorWindow_editor-window__28kFq"};